<div class="search-results-list-items">
  @for (item of results(); let i = $index; track item.itemId) {
    <div class="search-results-list-item">
      @if (bannerPlacingIndex() === i) {
        <div class="banners">
          <app-standard-dfp-banner-loader
            [isFluid]="true"
            [size]="[[560, 175]]"
            [unitName]="'/56297020/LISTBANNER_RESPONSIVE_560x175'"
          ></app-standard-dfp-banner-loader>
          <app-standard-dfp-banner-loader
            [isFluid]="true"
            [size]="[[950, 117]]"
            [unitName]="'/56297020/LISTBANNER_RESPONSIVE_950x117'"
          ></app-standard-dfp-banner-loader>
        </div>
      }

      @if (serpComponent() === SerpItemComponentEnum.CAREPROVIDER_WITH_SERVICES && item.isCustomer) {
        <app-careprovider-unit-item-v5
          [careproviderUnit]="item" [itemIndex]="i" [pageType]="pageType"
          [searchState]="searchState()">
        </app-careprovider-unit-item-v5>
      }
      @if (serpComponent() === SerpItemComponentEnum.CAREPROVIDER_WITH_SERVICES && !item.isCustomer) {
        <app-careprovider-unit-item-hsa
          [careproviderUnit]="item" [itemIndex]="i" [pageType]="pageType"
          [searchState]="searchState()">
        </app-careprovider-unit-item-hsa>
      }
      @if (serpComponent() === SerpItemComponentEnum.CARESERVICE) {
        <app-careprovider-unit-item-service [careproviderUnit]="item" [itemIndex]="i" [pageType]="pageType"
                                            [searchState]="searchState()">
        </app-careprovider-unit-item-service>
      }
    </div>
  }
</div>
